<template>
  <span>
    <v-snackbar
      content-class="snackbar"
      :color="snackbar.background"
      right
      v-model="snackbar.visible"
      :timeout="-1"
      :style="{
        marginRight: '200px',
        marginBottom: `${i * 180}px`,
        zIndex: 400,
      }"
      v-for="(snackbar, i) in items_snackbars"
      :key="i"
    >
      <v-icon :color="snackbar.icon_color" :size="64">{{
        snackbar.icon
      }}</v-icon>
      <h2 :style="{ color: snackbar.text_color + '!important' }" class="ml-16">
        {{ snackbar.text }}
      </h2>

      <v-btn
        @click="snackbar.visible = false"
        fab
        dark
        text
        small
        style="
          margin-top: -6rem;
          float: right !important;
          margin-right: -1rem !important;
        "
      >
        <v-icon :color="snackbar.icon_color">mdi-window-close</v-icon>
      </v-btn>
    </v-snackbar>
  </span>
</template>
<script>
export default {
  name: "SnackbarQV",
  components: {},
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      id_counter: 0,

      // Modal
      // Array
      items_snackbars: new Array(),
    };
  },
  computed: {},
  watch: {
    "items_snackbars.length": {
      immediate: true,
      handler() {
        if (this.items_snackbars.length == 0) {
          this.id_counter = 0;
        }
      },
    },
  },
  methods: {
    print(c, te, timeout = 3000) {
      // Preparo l'avviso.
      const snackbar = {
        id: this.id_counter++,
        visible: true,
        timeout: timeout,
        background:
          c === "success"
            ? "success"
            : c === "orange"
            ? "orange"
            : c === "error"
            ? "error"
            : "grey lighten-5",
        icon:
          c === "success"
            ? "mdi-check"
            : c === "orange"
            ? "mdi-alert"
            : c === "error"
            ? "mdi-close"
            : "mdi-information",
        icon_color:
          c === "success"
            ? "mdi-check"
            : c === "orange"
            ? "mdi-alert"
            : c === "error"
            ? "mdi-close"
            : "mdi-information",
        text: te,
        text_color:
          c === "success"
            ? "white"
            : c === "orange"
            ? "white"
            : c === "error"
            ? "white"
            : "black",
      };

      // Inserisco l'oggetto nell'array degli avvisi.
      this.items_snackbars.push(snackbar);

      /* Stabilisco l'intervallo di tempo che deve trascorrere
       * prima di eliminare questo specifico avviso.  */
      let that = this;
      setTimeout(() => {
        that.items_snackbars.forEach((elem, i) => {
          if (elem.id == snackbar.id) {
            that.items_snackbars.splice(i, 1);
          }
        });
      }, snackbar.timeout);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>